module.exports = __webpack_public_path__ + "img/bluesky24.166a5d60.jpg";